import { Box, Button, CircularProgress } from '@material-ui/core';

interface FormButtonProps extends React.ComponentProps<typeof Button> {
  loading?: boolean;
}

export function FormButton({ children, loading, ...props }: FormButtonProps) {
  return (
    <Button {...props}>
      <Box display="flex" alignItems="center" gridGap={8}>
        {loading && <CircularProgress color="inherit" size={16} />}
        {children}
      </Box>
    </Button>
  );
}
